import { useState } from 'react';

export default function useReloadState(): [number, () => void] {
	const [reloadDependency, setReloadDependency] = useState(0);
	const forceReload = () => setReloadDependency(r => r + 1);
	return [reloadDependency, forceReload];
}
